import React from 'react'
import PropTypes from 'prop-types'
import { Copy } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import SimpleModal from './SimpleModal'
import { MUTUAMAS_SERVICES_CONDITIONS } from 'commons/js/constants'

const TermsAndConditionsModal = ({ isShown, onClose, onAccept }) => {
    return <SimpleModal
      title={<FormattedMessage defaultMessage='¿Has aceptado los términos y condiciones?'/>}
      subtitle={<Copy fontSize='xSmall' fontWeight='regular' fontColor='black' padding='1em 1em 1em 0'>
          <FormattedMessage defaultMessage='Por favor, lee y acepta los {termAndCondition} para continuar con tu reserva' values={{
            termAndCondition: <Copy key='terms' textDecoration='underline' fontWeight='medium' fontColor='inherit' fontSize='inherit' font as='a' rel='noopener noreferrer' href={MUTUAMAS_SERVICES_CONDITIONS} target='_blank'>
                <FormattedMessage defaultMessage='términos y condiciones'/>
            </Copy>}} />
      </Copy>}
      imageSrc='/images/rental-car/terms-and-conditions.svg'
      isShown={isShown}
      onClose={onClose}
      onAccept={onAccept}
      acceptButtonText={<FormattedMessage defaultMessage='Entendido'/>}/>
}

TermsAndConditionsModal.propTypes = {
    isShown: PropTypes.bool,
    onClose: PropTypes.func,
    onAccept: PropTypes.func,
}
export default TermsAndConditionsModal
